import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Books from "@/pages/Books";
import Papers from "@/pages/Papers";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Radio from "@/pages/Radio";
import Music from "@/pages/Music";
import Essays from "@/pages/Essays";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import MorseChronicles from "@/pages/MorseChronicles";
import Press from "@/pages/Press";
import Newsletter from "@/pages/Newsletter";
import DXCC from "@/pages/DXCC";
import Widget from "@/pages/Widget";
import { PageViewTracker } from "@/components/PageViewTracker";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#F5F0E8] flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#0A1628] border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <PageViewTracker />
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/books" element={<Books />} />
          <Route path="/papers" element={<Papers />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/ad0k" element={<Radio />} />
          <Route path="/radio" element={<Radio />} />
          <Route path="/ad0k/DXCC" element={<DXCC />} />
          <Route path="/ad0k/widget" element={<Widget />} />
          <Route path="/music" element={<Music />} />
          <Route path="/essays" element={<Essays />} />
          <Route path="/genealogy" element={<Essays />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/press" element={<Press />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/MorseChronicles" element={<MorseChronicles />} />
        </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
